module.exports = __webpack_public_path__ + "img/tnc-active.dbd72da1.svg";